import React, { useContext, useEffect, useState } from "react";
import { DynamicComponentProps } from "../../core/_models";
import { TextField } from "@mui/material";

export function InputComponent({ context, config }: DynamicComponentProps) {
  const { title, id, value, readOnly, onPressEnter: action, inputType, required = false } = config;

  const [v, setValue] = useState(value);
  const formContext = useContext(context);

  useEffect(() => {
    formContext.set(id, v);
  }, [value]);

  return (
    <TextField
      id={id}
      label={title}
      defaultValue={v}
      margin="none"
      size="small"
      fullWidth={true}
      disabled={readOnly}
      required={required}
      onChange={readOnly
        ? () => {
        }
        : (e) => {
          setValue(e.target.value);
          formContext.set(id, e.target.value);
        }}
      onKeyPress={(e) => {
        if (e.key === "Enter" && action != null) {
          const empty = {};
          formContext.submit({ action, empty });
        }
      }}
      inputProps={{
        type: inputType ?? "text"
      }}
    />
  );
}